import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import useApi from "../../hook/useApi";
import Loader from "../Loader/Loader";
import { formatDateFull } from "../../utils/helper";

const SummaryTradesModal = ({ show, onHide, userId, userName, startDateTime, endDateTime, segment }) => {
  const { AsyncPostApiCall } = useApi();
  const [loading, setLoading] = useState(false);
  const [trades, setTrades] = useState([]);

  useEffect(() => {
    if (show && userId) {
      fetchTrades();
    }
  }, [show, userId]);

  const fetchTrades = async () => {
    setLoading(true);
    try {
      const res = await AsyncPostApiCall("/orders/history", {
        userId,
        startDate: startDateTime ? startDateTime.split("T")[0] : "",
        endDate: endDateTime ? endDateTime.split("T")[0] : "",
        segment: segment || "",
      });
      if (res?.success) {
        setTrades(res.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch trades", error);
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton className="bg-neutral-100 p-16">
        <Modal.Title className="h6 mb-0">
          Trading History - {userName}
          <small className="d-block text-secondary text-xs mt-1">
            {startDateTime ? `From ${startDateTime.replace("T", " ")}` : ""}
            {endDateTime ? ` To ${endDateTime.replace("T", " ")}` : ""}
          </small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {loading && <Loader />}
        <div className="table-responsive">
          <table className="table sm-table mb-0">
            <thead className="bg-neutral-50">
              <tr>
                <th className="small fw-bold">Date</th>
                <th className="small fw-bold">Type</th>
                <th className="small fw-bold">Symbol</th>
                <th className="small fw-bold">Qty</th>
                <th className="small fw-bold">Price</th>
                <th className="small fw-bold">LTP</th>
                <th className="small fw-bold">MTM</th>
                <th className="small fw-bold">Brokerage</th>
                <th className="small fw-bold">Status</th>
              </tr>
            </thead>
            <tbody>
              {!loading && trades.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center py-40 text-secondary">
                    No trade records found for this period.
                  </td>
                </tr>
              ) : (
                trades.map((t) => {
                  const isBuy = t.side === "BUY";
                  return (
                    <tr key={t._id}>
                      <td className="text-xs">
                        {formatDateFull(t.createdAt)}
                      </td>
                      <td>
                        <span className={`badge ${isBuy ? "bg-primary-focus text-primary-600" : "bg-danger-focus text-danger-600"} text-xxs`}>
                          {t.side}
                        </span>
                      </td>
                      <td className="fw-semibold text-primary-light text-xs">
                        {t.symbol}
                      </td>
                      <td className="text-xs">{t.quantity}</td>
                      <td className="text-xs">₹{t.executionPrice?.toFixed(2) || t.orderPrice?.toFixed(2)}</td>
                      <td className="text-xs">₹{t.ltp?.toFixed(2) || "-"}</td>
                      <td className={`text-xs fw-bold ${t.downlineMtm < 0 ? "text-danger" : "text-success"}`}>
                        ₹{t.downlineMtm?.toFixed(2)}
                      </td>
                      <td className="text-xs text-danger">₹{t.totalBrokerage?.toFixed(2)}</td>
                      <td>
                        <span className="badge bg-neutral-200 text-secondary text-xxs">
                          {t.status}
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-neutral-50 p-12">
        <button className="btn btn-secondary btn-sm radius-8" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SummaryTradesModal;
